import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { CalibrationSetModel } from 'src/app/models/calibrations/calibration-set.model';
import { CalibrationSetType } from 'src/shared/enums/calibration-set-type';
import { CloneUsesPopupComponent } from './clone-uses-popup/clone-uses-popup.component';
import ICalibrationSet = ZoneIQCalibration.ICalibrationSet;

@Component({
    standalone: false,
    selector: 'ziq-clone-uses-button',
    templateUrl: './clone-uses-button.component.html',
    styleUrls: ['./clone-uses-button.component.scss']

})
export class CloneUsesButtonComponent implements OnInit {

    constructor(
        private readonly dialog: MatDialog
    ) { }

    @Input()
    calibrationSet: CalibrationSetModel<ICalibrationSet>;

    @Input()
    calibrationSetType: CalibrationSetType;

    ngOnInit() {
    }

    openCloneUsesPopup() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '25%';
        dialogConfig.panelClass = 'popup-container';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            title: `Cloning Uses ${this.calibrationSet.Name}`,
            calibrationSet: this.calibrationSet,
            calibrationSetType: this.calibrationSetType
        };

        const publishDialogRef = this.dialog.open(CloneUsesPopupComponent, dialogConfig);
        publishDialogRef.afterClosed().subscribe();
    }

}
